import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const Privacy = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Privacy_Policy.pdf";

  return (
    <>
      <div className="about-container" style={{ marginTop: '30px', marginBottom: '15px' }}>
        <h1>Privacy Policy</h1>

        <div style={{ textAlign: 'left', maxWidth: '800px', width: '90%' }}>
          <div className="privacy-pdf-section" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading Privacy Policy document..." />
          </div>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default Privacy;
